import { faBug } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'components/button/Button';
import { usePermissions } from 'contexts/PermissionsContext';
import { memo } from 'react';
import { useDebug } from 'shared/debug/debug_store';
import { useThemeValues } from 'styles/theme';
import { KCFColor } from 'styles/themes/KCFColor';

function DebugToggle() {
    const { primaryText } = useThemeValues();
    const { isDebugMode, toggleIsDebugMode } = useDebug();
    const { canViewDebug } = usePermissions();

    return (
        <>
            {canViewDebug && (
                <Button
                    className="pl-10"
                    onClick={toggleIsDebugMode}
                    title="Toggle debug mode (alt+g)"
                >
                    <FontAwesomeIcon
                        icon={faBug}
                        color={isDebugMode ? KCFColor.primaryYellow : primaryText}
                    />
                </Button>
            )}
        </>
    );
}

const memoDebugToggle = memo(DebugToggle);
export { memoDebugToggle as DebugToggle };
